import { AuthClient } from '@/api/auth-client'

export const ReportAPI = new class ReportClient extends AuthClient {

    async getLeaderboard(metric: string, view: string, fromDate: Date, untilDate: Date ) {
        const response = await this.client.post(`/api/v1/reports/leaderboard`, {
            metric,
            view,
            fromDate,
            untilDate,
        }, {
            headers: {
                Accept: 'application/json',
            },
        })

        return response.data
    }

    async getReferralsConversion(view: string = 'user') {
        const response = await this.client.post(`/api/v1/reports/referrals_conversion`, {
            view,
        }, {
            headers: {
                Accept: 'application/json',
            },
        })

        return response.data
    }

    async getReferralsCount(groupBy: string, pipeline: string = null, view: string = 'user') {
        const response = await this.client.post(`/api/v1/reports/referrals_count`, {
            groupBy,
            pipeline,
            view,
        }, {
            headers: {
                Accept: 'application/json',
            },
        })

        return response.data
    }

    async getTargets() {
        const response = await this.client.post(`/api/v1/reports/targets`, {}, {
            headers: {
                Accept: 'application/json',
            },
        })

        return response.data
    }

}()
